export default __webpack_public_path__ + "static/media/silver-badge.aa6a17a3.svg";